<script>
import {store} from './store.js'

const unique = (value, index, self) => {
  return self.indexOf(value) === index
}

export default {

  name: 'VueWooProductNavBar',

  mounted(){
    this.fetchData()
  },


  data() {
    return {
        store,
        allProducts: [],
        productTypeCount: 0,
        productsLoading: true,

        allConditions: [],
        selectedCondition: '',

        allBerths: [],
        selectedBerths: '',

        shopURL: wp_field_vars.wc_shop_url,

      // theFormat: '', //this is meant to be a function if we do use it
        scaleClass: '',
        completed: false,
      }
    },


  methods: {

    fetchData: async function () {

      const products = await fetch(`/wp-json/goeuro/v1/products?skip_cache=1`)
        .then(response => response.json())
        .then(response => {
          this.productsLoading = false
          this.productTypeCount = response.length;
          response.map((item) => {
            this.allProducts.push(item)
          })
        });

      this.getAllConditions();
      this.getAllBerths();
    },


    getAllConditions: function() {
      const products = this.allProducts.filter(item => item.condition != null);
      let conditionsArr = products.map(product => product.condition);
      let uniqueConditions = [];

      conditionsArr.forEach(condition => {
        if(!uniqueConditions.some(item => item.name === condition.name)) {
          uniqueConditions.push(condition);
        }
      });

      this.allConditions = uniqueConditions.sort((a, b) => a.name.localeCompare(b.name));
    },


    getAllBerths: function() {
      const products = this.allProducts.filter(item => item.berths != '');
      let berthsArr = products.map(product => product.berths);
      let uniqueberths = berthsArr.filter(unique);
      this.allBerths = uniqueberths.sort((a, b) => a - b);
    },

    handleConditionSelect: function(event) {
      this.selectedCondition = event.target.value;

      let result = this.allProducts;
      if (this.selectedCondition) {
        result = result.filter(item => item.condition.slug == this.selectedCondition);
      }
      if (this.selectedBerths) {
        result = result.filter(item => item.berths == this.selectedBerths);
      }

      this.productTypeCount = result.length;
    },

    handleBerthSelect: function(event) {
      this.selectedBerths = event.target.value;

      let result = this.allProducts;
      if (this.selectedCondition) {
        result = result.filter(item => item.condition.slug == this.selectedCondition);
      }
      if (this.selectedBerths) {
        result = result.filter(item => item.berths == this.selectedBerths);
      }

      this.productTypeCount = result.length;
    },

  }
}

</script>


<template>
  <div class="productBar-nav-wrapper">

  <form method="GET" :action="shopURL" class="productBar-nav">
    <div class="select-wrapper">

      <select @change="handleConditionSelect" :disabled="productsLoading">
        <option disabled selected>New or used?</option>
        <option v-for="condition in allConditions" :value="condition.slug">{{condition.name}}</option>
      </select>

      <input hidden name="_condition" :value="this.selectedCondition"/>

    </div>

    <div class="select-wrapper">

    <select @change="handleBerthSelect" :disabled="productsLoading">
      <option disabled selected>How many berths?</option>
      <option v-for="berth in allBerths" :value="berth">{{berth}}</option>
    </select>

    <input hidden name="_berths" :value="this.selectedBerths"/>

    </div>

    <button type="submit" class="button primary" :disabled="productsLoading">
      <span class="tabular-nums-wrapper">
        View all&nbsp;
        <span class="tabular-nums">

<!--          <number-->
<!--          ref="number1"-->
<!--          :class="{scaleBig: scaleClass}"-->
<!--          :from="this.productTypeCount"-->
<!--          :to="this.productTypeCount"-->
<!--          :format="theFormat"-->
<!--          :duration="0.15"-->
<!--          @complete="completed"></number>-->
          <number
          ref="number1"
          :class="{scaleBig: scaleClass}"
          :from="this.productTypeCount"
          :to="this.productTypeCount"
          :duration="0.15"
          @complete="completed"></number>


        </span>
        &nbsp;Motorhomes
      </span>
      <span class="loader-wrapper" v-if="productsLoading">
        <span class="loader"></span>
      </span>
    </button>
    </form>
</div>
</template>
